module.exports = __webpack_public_path__ + "static/media/kuberan-silks.b675873c.png";